import { createSlice } from "@reduxjs/toolkit";
import { SendReportEmail } from "../thunks/reportEmailThunks";

interface ReportEmailState {
  loading: boolean;
  error: string | null;
  success: boolean;
  message: string | null;
}

const initialState: ReportEmailState = {
  loading: false,
  error: null,
  success: false,
  message: null,
};

const reportEmailSlice = createSlice({
  name: "reportEmail",
  initialState,
  reducers: {
    resetReportEmail: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(SendReportEmail.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(SendReportEmail.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message = action.payload.message;
      })
      .addCase(SendReportEmail.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || "שגיאה בשליחת המייל";
      });
  },
});

export const { resetReportEmail } = reportEmailSlice.actions;
export default reportEmailSlice.reducer;
